import { Browser } from './types';

type BrowserInfo = {
  name: Browser;
  version: number;
};

const isBrowserSupported = () => {
  try {
    return (
      'fetch' in window &&
      'Promise' in window &&
      'IntersectionObserver' in window &&
      'localStorage' in window &&
      'URLSearchParams' in window
    );
  } catch {
    return false;
  }
};

const parseBrowserInfo = (): BrowserInfo => {
  const ua = window.navigator.userAgent;

  const edgeMatch = ua.match(/Edg\/([0-9]+)/i) || ua.match(/Edge\/([0-9]+)/i);
  const firefoxMatch = ua.match(/Firefox\/([0-9]+)/i);
  const safariMatch = ua.match(/Version\/([0-9]+).*Safari/i);
  const chromeMatch = ua.match(/Chrome\/([0-9]+)/i);

  if (edgeMatch) {
    return { name: Browser.EDGE, version: Number(edgeMatch[1]) };
  }

  if (firefoxMatch) {
    return { name: Browser.FIREFOX, version: Number(firefoxMatch[1]) };
  }

  if (safariMatch && !ua.includes('Chrome') && !ua.includes('Chromium') && !ua.includes('Edg')) {
    return { name: Browser.SAFARI, version: Number(safariMatch[1]) };
  }

  if (chromeMatch && !ua.includes('Edg') && !ua.includes('OPR')) {
    return { name: Browser.CHROME, version: Number(chromeMatch[1]) };
  }

  return { name: Browser.UNKNOWN, version: 0 };
};

const isOutdatedBrowser = (minimumVersions: Record<Browser, number>) => {
  const browser = parseBrowserInfo();
  const minVersion = minimumVersions[browser.name];

  if (browser.version === 0) return true;

  return browser.version < minVersion;
};

export const BROWSER_WARNING = 'BROWSER_WARNING' as const;

export const isBrowserAllowed = (minimumVersions: Record<Browser, number>) =>
  isBrowserSupported() && !isOutdatedBrowser(minimumVersions);
